import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9767)">
      <path
        d="M0.5 3.83374L5.36237 11.2616H11.6617L10.2309 9.07495H14.7716L9.35162 17.3571L12.5 22.1662L24.5 3.83374L0.5 3.83374Z"
        fill="#ECEDEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5464_9767">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
